import { Navigate } from 'react-router';
import { useAppSelector } from '../../redux/hooks.ts';

export const AdminGuard = ({ children }: React.PropsWithChildren) => {
  const isAdmin = useAppSelector((state) => state.account.isAdmin);
  const impersonationUserId = localStorage.getItem('impersonation-user-id');

  // If impersonating, don't show Admin page
  if (impersonationUserId) {
    return <Navigate to="/" />;
  }

  if (!isAdmin) {
    return <Navigate to="/" />;
  }
  return children;
}
